import { MenuItem } from "primeng/api";

export const menuItems: MenuItem[]= 
[
    {
        label: 'Home',
        items: [{ label: 'Dashboard', icon: 'pi pi-fw pi-home', routerLink: ['/home'] }]
    },
    {
        label: 'Organizzazione',
        items: [
            { label: 'Clienti', icon: 'pi pi-fw pi-address-book', routerLink: ['/organization/clients'] },
            { label: 'Dipendenti', icon: 'pi pi-fw pi-users', routerLink: ['/organization/employers'] },
            { label: 'Macchinari', icon: 'pi pi-fw pi-wrench', routerLink: ['/organization/machines'] },
            { label: 'Fornitori', icon: 'pi pi-fw pi-shop', routerLink: ['/organization/suppliers'] },
            { label: 'Veicoli', icon: 'pi pi-fw pi-truck', routerLink: ['/organization/vehicles'] },
            { label: 'Tipi materiale', icon: 'pi pi-fw pi-qrcode', routerLink: ['/organization/equipments'] },
            { label: 'Tipi operazioni', icon: 'pi pi-fw pi-hammer', routerLink: ['/organization/operations'] }
        ]
    },
    {
        label: 'Commesse',
        items: [
            { label: 'Commesse', icon: 'pi pi-fw pi-copy', routerLink: ['/production/orders'] },
            { label: 'Posizioni', icon: 'pi pi-fw pi-file', routerLink: ['/production/positions'] },
            { label: 'Approvvigionamenti', icon: 'pi pi-fw pi-warehouse', routerLink: ['/production/equipment-requests'] }            
        ]
    },
    {
        label: 'Dettaglio Posizioni',
        items: [
            { label: 'Preventivi', icon :'pi pi-fw pi-calculator', routerLink: ['/workflow/preventives'] },
            { label: 'Progettazioni', icon: 'pi pi-fw pi-pen-to-square', routerLink: ['/workflow/projects'] },
            { label: 'Produzione',icon: 'pi pi-fw pi-list-check', routerLink: ['/workflow/productions'] },
            { label: 'Spedizioni', icon:'pi pi-fw pi-box', routerLink: ['/workflow/shippings'] },            
        ]
    },
    {
        label: 'Configurazione',
        items: [
            { label: 'Etichette', icon: 'pi pi-fw pi-tags', routerLink: ['/configuration/etiquettes'] },
            { label: 'Modelli', icon: 'pi pi-fw pi-clone', routerLink: ['/configuration/models'] },
           
        ]
    }
];